
import EditorTipTap from 'Editors/EditorTipTap'
import EditorList from 'Editors/EditorList'
export default {
  components: {
    EditorList,
    EditorTipTap,
  },
  data() {
    return {
      options: [
        {
          name: 'title',
          label: 'Naslov',
          type: 'text',
        },
      ],
      interneOpcije: [
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
        },
        {
          name: 'description',
          label: 'Description',
          type: 'tipTap',
        },
      ],
      optionsBorderBox: [
        {
          name: 'title',
          label: 'Naslov',
          type: 'text',
        },
        {
          name: 'subtitle',
          label: 'Podnaslov',
          type: 'tipTap',
        },
      ],
      borderBoxOpcije: [
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
        },
        {
          name: 'description',
          label: 'Description',
          type: 'tipTap',
        },
      ],
    }
  },
}
